import { render, staticRenderFns } from "./BaseSelectTable.vue?vue&type=template&id=5cbacaad"
import script from "./BaseSelectTable.vue?vue&type=script&lang=js"
export * from "./BaseSelectTable.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectTable.vue?vue&type=style&index=0&id=5cbacaad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports